{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(hemat {highestYearlyDiscount}%)",
    "{amount} days free": "Gratis {amount} hari",
    "{amount} off": "Diskon {amount}",
    "{amount} off for first {number} months.": "Diskon {amount} untuk {number} bulan pertama.",
    "{amount} off for first {period}.": "Diskon {amount} untuk {period} pertama.",
    "{amount} off forever.": "Diskon {amount} selamanya.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "Diskon {discount}%",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} tidak akan menerima buletin {newsletterName} lagi.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} tidak akan menerima email lagi ketika seseorang membalas komentar Anda.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} tidak akan menerima buletin ini lagi.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "Gratis {trialDays} hari",
    "{years} years": "",
    "+1 (123) 456-7890": "+62 123-4567-8900",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Akun",
    "Account details updated successfully": "Detail akun berhasil diperbarui",
    "Account settings": "Pengaturan akun",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Setelah percobaan gratis berakhir, Anda akan dikenai harga normal untuk tingkatan yang dipilih. Anda selalu dapat membatalkannya sebelum masa percobaan gratis berakhir.",
    "Already a member?": "Sudah menjadi anggota?",
    "An error occurred": "Terjadi kesalahan",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Terjadi kesalahan tak terduga. Harap coba lagi atau <a>hubungi layanan dukungan</a> jika kesalahan masih berlanjut.",
    "Back": "Kembali",
    "Back to Log in": "Kembali ke Halaman Masuk",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Batalkan kapan saja.",
    "Cancel subscription": "Batalkan langganan",
    "Canceled": "",
    "Cancellation reason": "Alasan pembatalan",
    "Change": "Ubah",
    "Change plan": "Ubah paket",
    "Check spam & promotions folders": "Periksa folder spam & promosi",
    "Check with your mail provider": "Hubungi penyedia layanan email Anda",
    "Check your inbox to verify email update": "Periksa kotak masuk Anda untuk memverifikasi pembaruan email",
    "Choose": "Pilih",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Pilih paket yang berbeda",
    "Choose a plan": "Pilih paket",
    "Choose a tier": "",
    "Choose your newsletters": "Pilih buletin Anda",
    "City": "",
    "Click here to retry": "Klik di sini untuk mencoba lagi",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Tutup",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Komentar",
    "Complimentary": "Pemberian gratis",
    "Confirm": "Konfirmasi",
    "Confirm cancellation": "Konfirmasi pembatalan",
    "Confirm subscription": "Konfirmasi langganan",
    "Contact support": "Hubungi layanan dukungan",
    "Continue": "Lanjutkan",
    "Continue subscription": "Lanjutkan berlangganan",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Tidak dapat membuat sesi checkout Stripe",
    "Could not sign in. Login link expired.": "Tidak dapat masuk. Tautan masuk telah kedaluwarsa.",
    "Could not update email! Invalid link.": "Tidak dapat memperbarui email! Tautan tidak valid.",
    "Country": "",
    "Create a new contact": "Buat kontak baru",
    "Current plan": "Paket saat ini",
    "Delete account": "Hapus akun",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Tidak bermaksud melakukan ini? Kelola preferensi Anda <button>di sini</button>.",
    "Don't have an account?": "Belum punya akun?",
    "Edit": "Edit",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Buletin email",
    "Email newsletter settings updated": "Pengaturan buletin email berhasil diperbarui",
    "Email preferences": "Preferensi email.",
    "Email preferences updated.": "",
    "Emails": "Email",
    "Emails disabled": "Email dinonaktifkan",
    "Ends {offerEndDate}": "Berakhir {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Masukkan alamat email Anda",
    "Enter your name": "Masukkan nama Anda",
    "Error": "Eror",
    "Expires {expiryDate}": "Kedaluwarsa {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Gagal membatalkan langganan, harap coba lagi",
    "Failed to log in, please try again": "Gagal masuk, harap coba lagi",
    "Failed to log out, please try again": "Gagal keluar, harap coba lagi",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Gagal memproses checkout, harap coba lagi",
    "Failed to send magic link email": "Gagal mengirim email magic link",
    "Failed to send verification email": "Gagal mengirim email verifikasi",
    "Failed to sign up, please try again": "Gagal mendaftar, harap coba lagi",
    "Failed to update account data": "Gagal memperbarui data akun",
    "Failed to update account details": "Gagal memperbarui detail akun",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Gagal memperbarui pengaturan buletin",
    "Failed to update subscription, please try again": "Gagal memperbarui langganan, harap coba lagi",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Selamanya",
    "Free Trial – Ends {trialEnd}": "Percobaan Gratis – Berakhir {trialEnd}",
    "From": "",
    "Get help": "Dapatkan bantuan",
    "Get in touch for help": "Hubungi untuk mendapatkan bantuan",
    "Get notified when someone replies to your comment": "Dapatkan pemberitahuan ketika seseorang menjawab komentar Anda",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Berikan masukan pada postingan ini",
    "Help! I'm not receiving emails": "Tolong! Saya tidak menerima email",
    "Here are a few other sites you may enjoy.": "Berikut beberapa situs lain yang mungkin akan Anda nikmati.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Jika buletin ditandai sebagai spam, email secara otomatis dinonaktifkan untuk alamat tersebut guna memastikan Anda tidak lagi menerima pesan yang tidak diinginkan.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Jika keluhan spam tersebut tidak disengaja, atau Anda ingin mulai menerima email lagi, Anda dapat berlangganan kembali untuk menerima email dengan mengklik tombol di layar sebelumnya.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Jika Anda membatalkan langganan sekarang, Anda akan tetap memiliki akses hingga {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Jika Anda memiliki akun email perusahaan atau pemerintah, hubungi departemen IT Anda dan mintalah mereka untuk mengizinkan pengiriman email dari {senderEmail} diterima.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Tautan masuk telah dikirim ke kotak masuk Anda. Jika tidak diterima dalam waktu 3 menit, pastikan untuk memeriksa folder spam Anda.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Jika Anda ingin mulai menerima email lagi, langkah-langkah terbaik selanjutnya adalah memeriksa alamat email Anda pada data yang tersimpan untuk memastikan tidak ada masalah, kemudian klik tombol 'berlangganan kembali' pada layar sebelumnya.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Jika Anda tidak menerima buletin email langganan Anda, berikut adalah beberapa hal yang perlu diperiksa.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Jika Anda telah melakukan semua pemeriksaan tersebut dan masih belum menerima email, Anda dapat menghubungi kami melalui kontak {supportAddress} untuk mendapatkan bantuan.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Jika terjadi kegagalan permanen saat mencoba mengirim buletin, email akan dinonaktifkan pada akun tersebut.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Pada klien email Anda, tambahkan {senderEmail} ke daftar kontak Anda. Hal ini akan memberikan sinyal kepada layanan email Anda bahwa email yang dikirim dari alamat ini harus dipercaya.",
    "Invalid email address": "Alamat email tidak valid",
    "Invalid verification code": "",
    "Jamie Larson": "Sutan T. Alisjahbana",
    "jamie@example.com": "sutan@example.com",
    "Less like this": "Kurangi yang seperti ini",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Pastikan email tidak berakhir di kotak masuk Spam atau Promosi Anda secara tidak sengaja. Jika ya, klik \"Tandai sebagai bukan spam\" dan/atau \"Pindahkan ke kotak masuk\".",
    "Manage": "Kelola",
    "Maybe later": "Mungkin nanti",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Keanggotaan tidak tersedia, hubungi pemilik situs untuk mendapatkan akses.",
    "month": "bulan",
    "Monthly": "Bulanan",
    "More like this": "Lebih banyak yang seperti ini",
    "More options": "",
    "Name": "Nama",
    "Need more help? Contact support": "Perlu bantuan lebih lanjut? Hubungi layanan dukungan",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Buletin dapat dinonaktifkan pada akun Anda dengan dua alasan: Email sebelumnya ditandai sebagai spam, atau percobaan pengiriman email menghasilkan kegagalan permanen (bounce).",
    "No member exists with this e-mail address.": "Tidak ada anggota yang terdaftar dengan alamat email ini.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Tidak menerima email?",
    "Now": "",
    "Now check your email!": "Sekarang periksa email Anda!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Setelah berlangganan kembali, jika Anda masih tidak melihat email di kotak masuk Anda, periksa folder spam. Beberapa penyedia layanan kotak masuk menyimpan catatan keluhan spam sebelumnya dan akan terus menandai email tersebut. Jika hal ini terjadi, tandai buletin terbaru sebagai 'Bukan spam' untuk memindahkannya kembali ke kotak masuk utama Anda.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Kegagalan permanen (bounce)",
    "Phone number": "Nomor telepon",
    "Plan": "Paket",
    "Plan checkout was cancelled.": "Pembayaran paket dibatalkan.",
    "Plan upgrade was cancelled.": "Peningkatan paket dibatalkan.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Harap hubungi {supportAddress} untuk mengubah langganan gratis Anda.",
    "Please enter {fieldName}": "Silakan masukkan {fieldName}",
    "Please fill in required fields": "Harap isi kolom yang wajib diisi",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Aktifkan kembali email",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Rekomendasi",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Perpanjang dengan harga {price}",
    "Resume subscription": "",
    "Retry": "Coba lagi",
    "Save": "Simpan",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Mengirim tautan masuk...",
    "Sending...": "Mengirim...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Tampilkan semua",
    "Sign in": "Masuk",
    "Sign out": "Keluar",
    "Sign up": "Daftar",
    "Signup error: Invalid link": "Kesalahan pendaftaran: Tautan tidak valid",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Terjadi kesalahan, silakan coba lagi nanti.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Maaf, itu tidak berhasil.",
    "Spam complaints": "Keluhan spam",
    "Start {amount}-day free trial": "Mulai percobaan gratis selama {amount} hari",
    "Starting {startDate}": "Dimulai pada {startDate}.",
    "Starting today": "Dimulai hari ini",
    "State": "",
    "Submit feedback": "Kirim masukan",
    "Subscribe": "Berlangganan",
    "Subscribed": "Telah berlangganan",
    "Subscription plan updated successfully": "Paket langganan berhasil diperbarui",
    "Success": "Berhasil",
    "Success! Check your email for magic link to sign-in.": "Berhasil! Periksa email Anda untuk mendapatkan tautan ajaib untuk masuk.",
    "Success! Your account is fully activated, you now have access to all content.": "Berhasil! Akun Anda telah diaktifkan sepenuhnya, sekarang Anda memiliki akses ke semua konten.",
    "Success! Your email is updated.": "Berhasil! Email Anda telah diperbarui.",
    "Successfully unsubscribed": "Berhasil berhenti berlangganan",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Terima kasih telah berlangganan. Sebelum Anda mulai membaca, berikut adalah beberapa situs lain yang mungkin akan Anda nikmati.",
    "Thank you for your support": "Terima kasih atas dukungan Anda",
    "Thank you for your support!": "Terima kasih atas dukungan Anda!",
    "Thanks for the feedback!": "Terima kasih atas masukannya!",
    "That didn't go to plan": "Itu tidak berjalan sesuai rencana",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Alamat email Anda yang kami miliki adalah {memberEmail} — jika itu tidak benar, Anda dapat memperbarui di <button>area pengaturan akun</button> Anda.",
    "There was a problem submitting your feedback. Please try again a little later.": "Terjadi masalah saat mengirimkan masukan Anda. Silakan coba sebentar lagi.",
    "There was an error cancelling your subscription, please try again.": "Terjadi kesalahan saat membatalkan langganan Anda, harap coba lagi.",
    "There was an error continuing your subscription, please try again.": "Terjadi kesalahan saat melanjutkan langganan Anda, harap coba lagi.",
    "There was an error processing your payment. Please try again.": "Terjadi kesalahan saat memproses pembayaran Anda. Harap coba lagi.",
    "There was an error sending the email, please try again": "Terjadi kesalahan saat mengirim email, harap coba lagi",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Situs ini hanya untuk yang diundang, hubungi pemiliknya untuk mendapatkan akses.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Situs ini tidak menerima pembayaran saat ini.",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Untuk menyelesaikan pendaftaran, klik tautan konfirmasi di kotak masuk Anda. Jika tidak diterima dalam waktu 3 menit, pastikan untuk memeriksa folder spam Anda!",
    "To continue to stay up to date, subscribe to {publication} below.": "Untuk tetap mendapatkan informasi terkini, silakan berlangganan ke {publication} di bawah ini.",
    "Too many attempts try again in {number} days.": "Terlalu banyak percobaan, coba lagi dalam {number} hari.",
    "Too many attempts try again in {number} hours.": "Terlalu banyak percobaan, coba lagi dalam {number} jam.",
    "Too many attempts try again in {number} minutes.": "Terlalu banyak percobaan, coba lagi dalam {number} menit.",
    "Too many different sign-in attempts, try again in {number} days": "Terlalu banyak percobaan masuk, coba lagi dalam {number} hari",
    "Too many different sign-in attempts, try again in {number} hours": "Terlalu banyak percobaan masuk, coba lagi dalam {number} jam",
    "Too many different sign-in attempts, try again in {number} minutes": "Terlalu banyak percobaan masuk, coba lagi dalam {number} menit",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Coba gratis selama {amount} hari, kemudian {originalPrice}.",
    "Unable to initiate checkout session": "Tidak dapat memulai sesi checkout",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Buka akses ke semua buletin dengan menjadi pelanggan berbayar.",
    "Unsubscribe from all emails": "Berhenti berlangganan dari semua email",
    "Unsubscribed": "Tidak berlangganan",
    "Unsubscribed from all emails.": "Telah berhenti berlangganan dari semua email.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Berhenti berlangganan dari email tidak akan membatalkan langganan berbayar Anda ke {title}",
    "Update": "Perbarui",
    "Update your preferences": "Perbarui preferensi Anda",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Tautan verifikasi telah dikirim, periksa kotak masuk Anda",
    "Verify your email address is correct": "Verifikasi bahwa alamat email Anda benar",
    "Verifying...": "",
    "View plans": "Lihat paket",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Kami tidak dapat menghentikan langganan Anda karena alamat email tidak ditemukan. Harap hubungi pemilik situs.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Selamat datang kembali, {name}!",
    "Welcome back!": "Selamat datang kembali!",
    "Welcome to {siteTitle}": "Selamat datang di {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Ketika sebuah kotak masuk gagal menerima sebuah email, hal tersebut umumnya disebut sebagai bounce. Dalam banyak kasus, ini bisa bersifat sementara. Namun, dalam beberapa kasus, email yang terbounce dapat dikembalikan sebagai kegagalan permanen ketika alamat email yang dituju tidak valid atau tidak ada.",
    "Why has my email been disabled?": "Mengapa email saya dinonaktifkan?",
    "X (Twitter)": "",
    "year": "tahun",
    "Yearly": "Tahunan",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Saat ini Anda memiliki keanggotaan gratis, tingkatkan ke langganan berbayar untuk akses penuh",
    "You have been successfully resubscribed": "Anda telah berhasil berlangganan kembali",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Anda saat ini tidak menerima email.",
    "You're not receiving emails": "Anda tidak menerima email.",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Anda tidak menerima email karena Anda telah menandai pesan terbaru sebagai spam, atau karena pesan tidak dapat dikirimkan ke alamat email yang Anda berikan.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Anda telah berhasil masuk.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Anda telah berhasil berlangganan ke <strong>{siteTitle}</strong>",
    "Your account": "Akun Anda",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Email Anda gagal berlangganan ulang, harap coba lagi",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Masukan Anda membantu membentuk apa yang dipublikasikan.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Langganan Anda akan berakhir pada {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Langganan Anda akan diperpanjang pada {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Langganan Anda akan dimulai pada {subscriptionStart}"
}
